<script lang="ts">
	import { page } from '$app/stores';
	import GlobalMedia from '$lib/components/media/GlobalMedia.svelte';
	import Link from '$lib/components/navigation/Link.svelte';
	import DirectusLink from '$lib/components/navigation/DirectusLink.svelte';
	import Text from '$lib/components/Text.svelte';
	import Media from '$lib/components/media/Media.svelte';
	import { cartChanged, openCart, optimisticCart } from '$lib/stores/shopStore';
	import { goto } from '$app/navigation';
	import { onDestroy, onMount } from 'svelte';
	import TopnavBanner from '$lib/components/layout/TopnavBanner.svelte';
	import Button from '$lib/components/util/Button.svelte';
	import Search from '$lib/components/layout/Search.svelte';
	import { getText } from '$lib/util/translations';
	import LangSwitcher from '../util/LangSwitcher.svelte';
	import LocationSwitcher from '../util/LocationSwitcher.svelte';
	import LocationsSwitcherBar from '../util/LocationsSwitcherBar.svelte';
	import { showLocationOptions } from '$lib/stores/shopStore';
	import { setCookie } from '$lib/util/helpers';

	export let menuOpen: boolean = false;

	let mainMenu: any;
	$: mainMenu = $page.data.menus.find((menu: any) => menu.internal_name === 'main_menu');
	$: accountMenu = $page.data.menus.find((menu: any) => menu.internal_name === 'account_menu');

	let subLinks: any[];
	let sublinkOffsetX: number = 0;
	let subMenuOpen: boolean = false;
	let searchOpen: boolean = false;
	let mobileSearchValue: string = '';
	let mobileSearchField: any = null;
	let accountMenuOpen: boolean;

	let openMobileSubMenus: any[] = [];

	function setSublinks(sl: any[], event: any = null) {
		if (event?.target) {
			sublinkOffsetX = event.target.offsetLeft;
		}
		if (sl && sl.length > 0) {
			subLinks = sl;
			subMenuOpen = true;
		} else {
			subLinks = [];
			subMenuOpen = false;
		}
	}

	function toggleMobileSubMenu(categoryId: any) {
		if (openMobileSubMenus.includes(categoryId)) {
			openMobileSubMenus.splice(openMobileSubMenus.indexOf(categoryId), 1);
			openMobileSubMenus = openMobileSubMenus;
		} else {
			openMobileSubMenus.push(categoryId);
			openMobileSubMenus = openMobileSubMenus;
		}
	}

	let y: number;
	let lastY: number;
	let headerCollapsed: boolean = false;

	let headerHeight = 0;

	let firstVisit = !$page.data.visited;

	onMount(() => {
		headerHeight =
			Number(
				getComputedStyle(document.documentElement)
					.getPropertyValue(`--header__height`)
					.replace('px', '')
			) ?? 0;
	});

	$: {
		let delta = y - lastY;
		headerCollapsed = y > headerHeight && delta > 0;
		lastY = y;
	}

	$: isLoggedIn = $page.data.customerToken;

	function mobileSearch() {
		goto('/' + $page.params.lang + '/shop?q=' + mobileSearchValue);
		mobileSearchValue = '';
		menuOpen = false;
	}

	function logout() {
		document.cookie = 'customer-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
		window.location.reload();
	}

	function toggleSearch() {
		searchOpen = !searchOpen;
	}

	let intervalId: number | null = null;

	onMount(() => {
		/*
		intervalId = setInterval(() => {
			showRegionalBanner = !showRegionalBanner;
		}, 4000);
		*/
	});

	onDestroy(() => {
		clearInterval(intervalId);
	});

	function selectLocation(location: string) {
		showLocationOptions.set(false);
		setCookie('location', location, 365);
		window.location.reload();
	}
</script>

<svelte:window bind:scrollY={y} />
<TopnavBanner headerCollapsed={headerCollapsed && !menuOpen} />
<Search
	{searchOpen}
	headerCollapsed={headerCollapsed && !menuOpen}
	on:closeSearch={() => {
		searchOpen = false;
	}}
/>
<header
	class:collapsed={headerCollapsed && !menuOpen}
	class:submenu-open={subMenuOpen}
	on:mouseleave={() => {
		setSublinks([], null);
	}}
>
	<div class="header-wrapper {$page.data.langDirection}">
		<div class="inner-header" class:firstVisit>
			<div class="burger-wrapper">
				<button
					class="burger-button"
					id="nav-icon3"
					class:open={menuOpen}
					aria-label={getText($page.data.globalTexts, 'menu-aria').text}
					on:click={() => {
						menuOpen = !menuOpen;
					}}
				>
					<span />
					<span />
					<span />
					<span />
				</button>
			</div>

			<div class="left">
				<Link
					link="home"
					aria_label="Home"
					type="internal"
					on:click={() => {
						menuOpen = false;
					}}
				>
					<div class="logo">
						<GlobalMedia key="logo" />
					</div>
				</Link>
				<div class="links">
					{#each mainMenu?.links ?? [] as link}
						<div class="links-wrapper">
							{#if link.link_id.type === 'category' && !link.link_id.page && !link.link_id.link}
								<div
									class="header-link"
									class:active={$page.url.pathname.startsWith(
										'/' + $page.params.lang + '/' + link.link_id.page?.slug
									)}
									on:mouseenter={(e) => {
										setSublinks(link.link_id.sublinks, e);
									}}
									on:click={() => (subMenuOpen = false)}
								>
									{link.link_id.display_text}
								</div>
							{:else}
								<DirectusLink {...link.link_id}>
									<div
										class="header-link"
										class:active={$page.url.pathname.startsWith(
											'/' + $page.params.lang + '/' + link.link_id.page?.slug
										)}
										on:mouseenter={(e) => {
											setSublinks(link.link_id.sublinks, e);
										}}
										on:click={() => (subMenuOpen = false)}
									>
										{link.link_id.display_text}
									</div>
								</DirectusLink>
							{/if}
						</div>
					{/each}
				</div>
			</div>
			<div class="right">
				<button
					class="icon-link search-desktop"
					on:click={toggleSearch}
					aria-label={getText($page.data.globalTexts, 'search').text}
				>
					<GlobalMedia key="icon-search" />
				</button>
				<div
					class="account-link account-wrapper"
					class:open={accountMenuOpen}
					on:click={() => {
						accountMenuOpen = !accountMenuOpen;
					}}
					on:mouseenter={() => {
						accountMenuOpen = true;
					}}
					on:mouseleave={() => {
						accountMenuOpen = false;
					}}
				>
					<div class="account-menu-item">
						<div class="account-text desktop"><Text key="ecom_account" /></div>
						<div class="icon-link">
							<GlobalMedia key="icon-account" />
						</div>
					</div>
					<div class="account-submenu" class:open={accountMenuOpen}>
						{#if isLoggedIn}
							<div
								class="link-line"
								on:click={() => {
									accountMenuOpen = false;
								}}
							>
								<Link type="internal" link="profile">
									<div class="text"><Text key="ecom_nav_profile" /></div>
									<div class="icon"><GlobalMedia key="icon-arrow-right" /></div>
								</Link>
							</div>
							<div
								class="link-line"
								on:click={() => {
									accountMenuOpen = false;
								}}
							>
								<Link type="internal" link="orders">
									<div class="text"><Text key="ecom_nav_orders" /></div>
									<div class="icon"><GlobalMedia key="icon-arrow-right" /></div>
								</Link>
							</div>
							<div
								class="link-line"
								on:click={() => {
									accountMenuOpen = false;
								}}
							>
								<Link type="internal" link="settings">
									<div class="text"><Text key="ecom_nav_settings" /></div>
									<div class="icon"><GlobalMedia key="icon-arrow-right" /></div>
								</Link>
							</div>
							<div
								class="link-line"
								on:click={() => {
									accountMenuOpen = false;
								}}
							>
								<Link type="internal" link="subscriptions">
									<div class="text"><Text key="ecom_nav_subscriptions" /></div>
									<div class="icon"><GlobalMedia key="icon-arrow-right" /></div>
								</Link>
							</div>
							<div
								class="button-wrapper"
								on:click={() => {
									accountMenuOpen = false;
								}}
							>
								<div class="sublink submenu-item">
									<Button
										type="custom"
										style="dark"
										size="medium"
										variant="outline"
										textKey="ecom_logout"
										iconKey="icon-arrow-out"
										on:click={logout}
									/>
								</div>
							</div>
						{:else}
							<div class="title"><Text key="account_menu_title" /></div>
							<div class="line">
								<div class="icon"><GlobalMedia key="account_menu_line1" /></div>
								<Text key="account_menu_line1" />
							</div>
							<div class="line">
								<div class="icon"><GlobalMedia key="account_menu_line2" /></div>
								<Text key="account_menu_line2" />
							</div>
							<div class="line">
								<div class="icon"><GlobalMedia key="account_menu_line3" /></div>
								<Text key="account_menu_line3" />
							</div>
							<Link type="internal" link="signup">
								<Button type="custom" style="dark" size="medium" textKey="ecom_create_account" />
							</Link>
							<Link type="internal" link="login">
								<Button
									type="custom"
									style="dark"
									size="medium"
									variant="outline"
									textKey="ecom_login"
								/>
							</Link>
						{/if}
					</div>
				</div>

				<button
					class="cart icon-link"
					class:changed={$cartChanged}
					on:click={openCart}
					aria-label={getText($page.data.globalTexts, 'cart-aria').text}
				>
					<GlobalMedia key="icon-cart" />
					{#if $optimisticCart?.lines?.edges?.length && $optimisticCart?.lines?.edges?.length > 0}
						<div class="product-indicator">
							{Math.min(9, $optimisticCart?.lines?.edges?.length)}{$optimisticCart?.lines?.edges
								?.length > 9
								? '+'
								: ''}
						</div>
					{/if}
				</button>
			</div>
			<div class="menu" class:open={menuOpen}>
				<div class="header-line" />
				<div class="shop-links">
					{#each mainMenu?.links?.[0]?.link_id?.sublinks ?? [] as sublink}
						{#key sublink.id}
							<div
								class="sublink"
								on:click={() => {
									menuOpen = false;
								}}
							>
								<DirectusLink {...sublink}>
									<div class="icon">
										<Media {...sublink.icon} />
									</div>
									<div class="text">
										<div class="link-text">{sublink.display_text}</div>
										{#if sublink.description}
											<div class="link-descripton">{sublink.description}</div>
										{/if}
									</div>
								</DirectusLink>
							</div>
						{/key}
					{/each}
				</div>
				<div class="mobile-search">
					<form
						on:submit|preventDefault={() => {
							mobileSearch();
						}}
						action="."
					>
						<input
							type="search"
							bind:this={mobileSearchField}
							bind:value={mobileSearchValue}
							placeholder="Search Products"
						/>
						<div
							class="search-icon {$page.data.langDirection}"
							on:click={() => {
								mobileSearch();
							}}
						>
							<GlobalMedia key="icon-search2" />
						</div>
					</form>
				</div>
				<div class="menu-links">
					{#each mainMenu?.links?.slice(1) ?? [] as link}
						<div class="link-wrapper">
							{#if link.link_id.type === 'category' && link.link_id.sublinks?.length > 0}
								<div
									class="link"
									on:click={() => {
										toggleMobileSubMenu(link.link_id.id);
									}}
								>
									{link.link_id.display_text}
								</div>
								<div class="sublinks" class:open={openMobileSubMenus.includes(link.link_id.id)}>
									{#each link.link_id.sublinksx as sublink}
										<div
											class="sublink"
											on:click={() => {
												menuOpen = false;
											}}
										>
											<DirectusLink {...sublink}>
												{sublink.display_text}
											</DirectusLink>
										</div>
									{/each}
								</div>
							{:else}
								<div
									class="link"
									on:click={() => {
										menuOpen = false;
									}}
								>
									<DirectusLink
										{...link.link_id}
										on:click={() => {
											menuOpen = !menuOpen;
										}}
									>
										<div>
											{link.link_id.display_text}
										</div>
										<div class="icon">
											<GlobalMedia key="icon-arrow-right" />
										</div>
									</DirectusLink>
								</div>
							{/if}
						</div>
					{/each}
				</div>
				<div class="switchers-wrapper">
					<div class="lang-switcher">
						<LangSwitcher />
					</div>

					<div class="location-switcher">
						<LocationSwitcher
							on:click={() => {
								showLocationOptions.set(!$showLocationOptions);
							}}
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
	<LocationsSwitcherBar
		open={$showLocationOptions}
		on:close={() => {
			showLocationOptions.set(false);
		}}
		on:onlocationchange={(event) => {
			selectLocation(event.detail.location);
		}}
	/>
	<div class="submenu" class:open={subMenuOpen}>
		<div class="inner-menu">
			<div class="sublinks">
				{#if subLinks && subLinks.length > 0}
					{#each subLinks as sublink}
						{#key sublink.id}
							<div
								class="sublink"
								on:click={() => {
									subMenuOpen = false;
								}}
							>
								<DirectusLink {...sublink}>
									<div class="icon">
										<Media {...sublink.icon} />
									</div>
									<div class="text">
										{#if sublink.display_text}
											<div class="link-text">{sublink.display_text}</div>
										{/if}
										{#if sublink.description}
											<div class="link-descripton">{sublink.description}</div>
										{/if}
									</div>
								</DirectusLink>
							</div>
						{/key}
					{/each}
				{/if}
				{#each Array(0) as i}
					<div class="sublink">
						<DirectusLink>
							<div class="icon">
								<GlobalMedia key="icon-capsules-bw" />
							</div>
							<div class="text">
								<div class="link-text">Lorem ipsum</div>
								<div class="link-descripton">Lorem ipsum dolor sit</div>
							</div>
						</DirectusLink>
					</div>
				{/each}
			</div>
			<div class="right">
				<div class="card">
					<DirectusLink {...$page.data.globals.header_card_link}>
						<div class="text">
							<div class="title">{$page.data.globals.header_card_link.description}</div>
							<Button
								size="small"
								style="yellow"
								display_text={$page.data.globals.header_card_link.display_text}
								icon={$page.data.globals.header_card_link.icon}
							/>
						</div>
						<div class="image">
							<Media {...$page.data.globals.header_card_media} fit="cover" />
						</div>
					</DirectusLink>
				</div>
			</div>
		</div>
	</div>
	<div class="overlay" class:open={subMenuOpen || menuOpen} />
</header>

<style lang="scss">
	$banner-height: v(header__banner__height);
	$mobileBreakpoint: 1400px;

	.cart {
		position: relative;
		&.changed {
			animation: bounce 0.5s;
		}

		.product-indicator {
			position: absolute;
			bottom: -6px;
			inset-inline-start: 0;
			background: black;
			color: white;
			width: 14px;
			height: 14px;
			border-radius: 14px;
			box-sizing: border-box;
			padding-top: 0.2em;
			display: flex;
			justify-content: center;
			align-items: center;
			@include font(text-xs);
			font-size: 0.7rem;
			@include media(tablet) {
				left: 10px;
			}
		}
	}

	.search-desktop {
		@media (max-width: $mobileBreakpoint) {
			display: none !important;
		}
	}

	.account-link {
		display: flex;

		.account-text {
			@include font(h6);
			margin-top: 3px;

			@media (max-width: $mobileBreakpoint) {
				display: none !important;
			}
		}

		:global(svg) {
			height: 20px !important;
		}

		:global(img) {
			height: 20px !important;
		}

		/*
		&.mobile {
			@include min-media(phone) {
				display: none;
			}
		}

		&.desktop {
			@include media(phone) {
				display: none;
			}
		}
		*/
	}

	.account-wrapper {
		position: relative;
		$padding: v(content-gap);
		padding: $padding;
		margin: calc(-1 * $padding);

		@media (max-width: $mobileBreakpoint) {
			padding: 0 v(content-padding-lg);
		}

		.account-menu-item {
			cursor: pointer;
		}

		.account-submenu {
			position: absolute;
			top: calc(v(header__nav__height) + 2px);
			inset-inline-start: 50%;
			transform: translate(calc(v(dir) * -50%), -32px);
			width: 340px;
			max-width: 90vw;
			z-index: 5;

			padding: v(content-padding);
			background: white;
			border-radius: v(border-radius);
			box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);

			display: flex;
			flex-direction: column;
			opacity: 0;
			@include transition(all);
			pointer-events: none;

			display: flex;
			flex-direction: column;

			&.open {
				opacity: 1;
				pointer-events: auto;
				transform: translate(calc(v(dir) * -50%), 0);
			}

			@media (max-width: $mobileBreakpoint) {
				position: fixed;
				width: 100%;
				top: calc(v(header__nav__height) + 8px);
			}

			.title {
				@include font(h5);
				margin-bottom: v(content-padding-sm);
			}

			.line {
				@include font(text-sm);
				display: flex;
				margin-bottom: 2px;

				.icon {
					width: 32px;
				}
			}

			.link-line {
				width: 100%;

				border-bottom: 1px solid color(grey_03);

				:global(a) {
					width: 100%;

					display: flex;
					justify-content: space-between;
					align-items: center;
					padding: v(content-padding-xs) 0;
					color: color(black);

					&:hover {
						text-decoration: underline;
					}
				}

				.icon {
					display: flex;
					align-items: center;
					width: 16px;
				}

				.text {
					padding-top: 0.4rem;
				}
			}

			.button-wrapper {
				margin-top: 8px;
			}

			:global(button) {
				width: 100%;
				display: flex;
				justify-content: center;
				margin-top: 4px;
				gap: 4px;
			}
		}

		/*
		@media (hover: hover) {
			&:hover {
				.account-submenu {
					opacity: 1;
					pointer-events: auto;
					transform: translate(calc(v(dir) * -50%), 0);
				}
			}
		}
			*/
	}

	.account-menu-item {
		display: flex;
		gap: v(content-padding-xs);
		@include font(info-lg);
		align-items: center;
		color: color(black);
	}

	header {
		position: fixed;
		display: flex;
		justify-content: center;
		top: $banner-height;
		inset-inline-start: 0;
		width: 100%;
		height: v(header__nav__height);
		transform: translateY(0);
		transition: all 0.3s ease;

		@include media(phone) {
			.burger-wrapper,
			.right {
				width: 30%;
			}
		}

		&.submenu-open {
			.header-wrapper {
				background: color(white);
			}
		}

		.header-wrapper {
			width: 100%;
			padding: 0 v(page-padding) 0 2rem;
			background: color(yellow);
			@include transition(all);

			&.rtl {
				padding: 0 2rem 0 v(page-padding);
			}

			// @media (max-width: 1100px) {
			// 	padding: 0 v(content-gap);
			// }

			@media (max-width: $mobileBreakpoint) {
				padding: 0 v(page-padding);
			}

			@include media(phone) {
				padding: 0 v(page-padding);
			}
		}

		z-index: 100;

		&.collapsed {
			transform: translateY(calc(-1 * v(header__nav__height)));
			top: 0;
		}

		.icon-link {
			display: flex;
			transform: scale(1);
			transition: all 0.4s ease;
			border: 0;
			background: transparent;

			&:hover {
				transform: scale(1.1);
			}

			:global(img) {
				height: 20px;
			}

			:global(svg) {
				height: 20px;
			}
		}

		.overlay {
			position: fixed;
			top: v(header__nav__height);
			inset-inline-start: 0;
			width: 100vw;
			height: calc(100vh - v(header__nav__height));
			width: 100dvw;
			height: calc(100dvh - v(header__nav__height));
			background: rgba(0, 0, 0, 0.2);
			z-index: -2;
			pointer-events: none;
			opacity: 0;
			transition: all 0.3s ease;

			&.open {
				opacity: 1;
			}
		}

		@keyframes entry-anim {
			0% {
				transform: translateY(16px);
				opacity: 0;
			}
			100% {
				transform: translateY(0);
				opacity: 1;
			}
		}

		.inner-header {
			position: relative;
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			// max-width: v(max-width);
			z-index: 10;
			height: 100%;
			gap: v(content-gap);

			&.firstVisit {
				animation: entry-anim 0.4s cubic-bezier(0.25, 1, 0.5, 1) 2.5s both;
			}
		}

		.burger-wrapper {
			display: none;

			@media (max-width: $mobileBreakpoint) {
				display: flex;
				align-items: center;
				width: 33%;
			}
		}

		.left {
			display: flex;
			align-items: center;
			gap: 16px;
			height: 100%;
			flex-shrink: 0;

			@include media(phone) {
				justify-content: center;
			}

			:global(svg) {
				max-width: 101px;
			}
		}

		.right {
			display: flex;
			align-items: center;
			justify-content: flex-end;
			gap: v(content-padding-lg);
			height: 100%;
			z-index: 2;
			flex-shrink: 0;

			:global(svg) {
				max-width: 22px;
			}

			@media (max-width: $mobileBreakpoint) {
				gap: v(content-padding);
				width: 33%;
			}
		}
	}
	.logo {
		height: 57px;
		max-width: 57px;
		display: flex;
		margin-inline-end: v(content-padding-xs);
		cursor: pointer;

		@include media(tablet) {
			height: 44px;
			max-width: 27px;
			margin-inline-end: 0;
		}

		:global(img) {
			object-position: left;
		}
	}

	.links {
		display: flex;
		gap: v(content-padding-lg);
		@include font(h5-header);
		cursor: pointer;

		.header-link {
			margin-inline-start: 8px;
			color: color(black);
			margin-top: 0.4rem;

			text-decoration-color: transparent;
			transition: all 0.3s ease;
			cursor: pointer;

			&:hover,
			&.active {
				text-decoration: underline;
				text-underline-offset: 0.25em;
				text-decoration-thickness: 1px;
				text-decoration-color: color(camel);
			}
		}

		@media (max-width: 1250px) {
			gap: v(content-padding-sm);
		}

		@media (max-width: $mobileBreakpoint) {
			display: none;
		}
	}
	.switchers-wrapper {
		display: none;
		@media (max-width: 600px) {
			:global(.switcher-dropdown) {
				transform: translate(-64%, -150px) !important;
			}
			display: flex;
			gap: v(content-gap);
			position: relative;
			margin-bottom: v(content-gap-xl);
			:global(.lang-selector),
			:global(.location-selector) {
				background: color(grey_01) !important;
			}
		}
	}
	.location-switcher {
		// @include media(phone) {
		// 	display: none;
		// }
	}

	.header-button {
		padding: 9px 32px;
		cursor: pointer;

		@include font(cta);
		color: color(black);
		transition: all 0.3s ease;

		@media (max-width: 1200px) {
			padding: 9px 24px;
		}

		@media (max-width: 1100px) {
			padding: 9px 16px;
		}

		&:hover {
			background: color(primary);
			color: white;
		}
	}

	.burger-button {
		display: none;
		border: none;
		background: transparent;

		width: 30px;
		height: 22px;
		position: relative;
		transform: rotate(0deg);
		transition: 0.5s ease-in-out;
		cursor: pointer;

		span {
			display: block;
			position: absolute;
			height: 1.3px;
			width: 100%;
			background: color(black);
			opacity: 1;
			inset-inline-start: 0;
			transform: rotate(0deg);
			transition: 0.25s ease-in-out;
		}

		@media (max-width: $mobileBreakpoint) {
			display: inline-block;
		}
	}

	.burger-button span:nth-child(1) {
		top: 0px;
	}

	.burger-button span:nth-child(2),
	.burger-button span:nth-child(3) {
		top: calc(50% - 1px);
	}

	.burger-button span:nth-child(4) {
		top: calc(100% - 2px);
	}

	/* Hover state */
	// .burger-button:hover span:nth-child(1) {
	// 	top: calc(10%);
	// 	width: 100%;
	// 	inset-inline-start: 10%;
	// }

	// .burger-button:hover span:nth-child(4) {
	// 	top: calc(90%);
	// 	width: 100%;
	// 	inset-inline-start: 10%;
	// }

	/* Open state */
	.burger-button.open span:nth-child(1) {
		top: calc(50% - 1px);
		width: 0%;
		inset-inline-start: 50%;
	}

	.burger-button.open span:nth-child(2) {
		transform: rotate(45deg);
	}

	.burger-button.open span:nth-child(3) {
		transform: rotate(-45deg);
	}

	.burger-button.open span:nth-child(4) {
		top: calc(50% - 1px);
		width: 0%;
		inset-inline-start: 50%;
	}

	.submenu {
		position: absolute;
		top: v(header__nav__height);
		inset-inline-start: 0;
		width: 100vw;
		background: color(white);
		padding: v(content-padding-sm) v(page-padding) v(content-padding-lg) v(page-padding);
		color: color(black);
		opacity: 0;
		transform: translateY(-40px);
		pointer-events: none;
		transition: all 0.4s ease;
		z-index: -1;

		display: flex;
		justify-content: center;
		grid-gap: v(content-gap-xs);

		&.open {
			opacity: 1;
			transform: translateY(0);
			pointer-events: auto;
		}

		.inner-menu {
			position: relative;
			display: flex;
			justify-content: space-between;
			gap: v(content-padding-lg);
			width: 100%;
			max-width: v(max-width);
		}

		.right {
			@include font(h5);
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: space-between;
			gap: v(content-gap);

			.logo-wrapper {
				height: 5rem;
				:global(svg path),
				:global(svg polygon) {
					fill: color(white);
				}
			}
		}

		.sublinks {
			display: grid;
			grid-template-columns: repeat(3, minmax(0, 1fr));
			gap: v(content-padding-xs);
			width: 100%;
			height: 100%;
		}

		.card :global(a) {
			position: relative;
			display: flex;
			align-items: flex-end;
			width: min(30vw, 500px);
			height: 100%;
			background: color(beige);
			color: color(black);
		}

		.card {
			height: 100%;

			.text {
				width: 100%;
				padding: v(content-padding);

				.subtitle {
					@include font(info-sm);
					margin-bottom: v(content-padding-sm);
				}

				.title {
					@include font(h4);
					color: white;
					max-width: 60%;
					margin-bottom: v(content-padding);
				}
			}

			.image {
				position: absolute;
				inset: 0;
				z-index: -1;
				filter: brightness(0.7);
			}

			@media (max-width: 1300px) {
				// display: none;
			}
		}
	}
	.sublink {
		height: 100%;

		.link-text {
			margin-top: 0.1rem;
			@include font(h6);
		}

		.link-description {
			@include font(text-sm);
			font-weight: 400;
		}

		.icon {
			width: 34px;
			display: flex;
			align-items: center;
			flex-shrink: 0;
		}

		&:first-child {
			:global(a),
			.sublink-content {
				height: 100%;
				background: color(yellow_01);
			}
		}

		:global(a),
		.sublink-content {
			width: 100%;
			color: color(black);
			cursor: pointer;
			position: relative;
			width: 100%;
			z-index: 2;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			overflow-wrap: break-word;
			transition: all 0.3s ease;
			text-decoration-color: transparent;
			padding: v(content-padding-xs) v(content-padding-sm);
			gap: v(content-padding);

			background: white;

			@include font(text-sm);

			&:hover {
				background: color(yellow_02);
			}
		}
	}

	.menu {
		position: fixed;
		top: v(header__nav__height);
		opacity: 0;
		inset-inline-end: -10vh;
		width: 50vw;
		height: calc(100dvh - v(header__nav__height));
		background: color(white);
		padding: v(content-padding);
		transition: all 0.3s ease;
		z-index: 1000;
		pointer-events: none;
		overflow-y: scroll;

		.header-line {
			position: absolute;
			top: calc(-1 * v(header__nav__height));
			inset-inline-start: -1px;
			width: 1px;
			height: v(header__nav__height);
			background: color(primary);
		}

		.link-wrapper {
			display: flex;
			flex-direction: column;
			margin-bottom: 8px;
		}

		.link-wrapper :global(a) {
			width: 100%;
		}

		.header-button {
			width: 100%;
			display: flex;
			justify-content: center;
		}

		.shop-links {
			display: grid;
			grid-template-columns: 1fr 1fr;
			gap: 8px;
			margin-bottom: v(content-padding);

			.sublink {
				:global(a) {
					gap: 12px;
					padding: 8px;
					margin-bottom: 0;
					background: color(grey_01);
					height: 100%;
				}

				&:first-child {
					grid-column: 1 / 3;
					border-radius: 4px;
					overflow: hidden;

					:global(a) {
						background: color(yellow_01);
					}
				}

				.link-descripton {
					@include font(text-xs);
					margin-top: 4px;
				}
			}
		}

		&.open {
			inset-inline-end: -1px;
			top: v(header__nav__height);
			opacity: 1;
			pointer-events: auto;
		}

		.menu-links {
			display: flex;
			flex-direction: column;

			.link-wrapper {
				.link {
					color: color(black);
					@include font(h5);
					padding-bottom: 8px;
					border-bottom: 1px solid rgba(0, 0, 0, 0.2);

					@media (max-width: 600px) {
						display: flex;
					}

					:global(a) {
						color: color(black);
						display: flex;
						justify-content: space-between;
					}
				}

				.icon {
					max-width: 16px;
				}
				margin-bottom: v(content-padding-sm);
			}
		}

		.sublinks {
			margin: 16px 0 8px 0;
			display: none;

			&.open {
				display: flex;
				flex-direction: column;
			}
		}

		.sublink {
			display: flex;
			flex-direction: column;

			width: 100%;
			margin-bottom: 8px;

			:global(a) {
				width: 100%;

				@include font(info);
				color: color(black);

				@media (max-width: 600px) {
					display: flex;
				}

				&:hover {
					text-decoration: none;
				}
			}
		}

		@media (min-width: 1400px) {
			display: none;
			pointer-events: none;
		}

		@include media(phone) {
			top: calc(v(header__nav__height) + 10vh);
			width: calc(100vw + 2px);
			border-inline-start: none;
			inset-inline-end: 0;
		}
	}

	.mobile-search {
		position: relative;
		margin-bottom: 16px;

		form {
			width: 100%;
		}

		input {
			width: 100%;
			padding: v(content-padding-sm);
			margin-bottom: v(content-padding);
			box-sizing: border-box;
			border: 0;
			border-bottom: 1px solid #ccc;
			background: color(grey_01);
			@include font(h6);
			@include media(phone) {
				font-size: 16px;
			}
		}

		.input-wrapper {
			position: relative;
			display: flex;
			align-items: center;
			gap: v(content-padding);
		}

		.search-icon {
			position: absolute;
			top: 15px;
			inset-inline-end: 12px;
			max-width: 28px;
			cursor: pointer;

			&.rtl {
				inset-inline-end: unset;
				inset-inline-start: 12px;
			}
		}
	}
</style>
